import { Suspense, lazy } from 'react'
import { Switch, Redirect, Route } from 'react-router-dom'
import { Mode } from '@ocean/types/dist/appearance'
import { common } from '@ocean/ui'
import simulatorTrainingRoutes from 'modules/simulatorTrainings/common/routing/routes'
import routes from './routes'

const { RouteChangeProgress } = common

export { routes }

export const ExerciseSheet = lazy(
  () =>
    import(
      /* webpackChunkName: "SimulatorTrainingInstructorSLExerciseSheet" */ 'modules/simulatorTrainings/instructor/studentLed/ExerciseSheet/pages/ExerciseSheet'
    )
)

const ExerciseSheetRouting = () => (
  <Suspense fallback={<RouteChangeProgress mode={Mode.Light} />}>
    <Switch>
      <Route exact path={`${routes.root}/:exerciseId`} component={ExerciseSheet} />
      <Redirect path='*' to={simulatorTrainingRoutes.root} />
    </Switch>
  </Suspense>
)

export default ExerciseSheetRouting
